export const GameTypeEnum = {
    Live: 1,
    Prematch: 2,
};

export const GameTypeViewEnum = {
    [GameTypeEnum.Live]: 'live',
    [GameTypeEnum.Prematch]: 'prematch',
};